import { CompleteOnboardingInput, OnboardingFlowQuery, OnboardingFlowRevision, OnboardingOptionCatalogue, OnboardingStatusView, SaveOnboardingStepInput, StartOnboardingPhoneBindingInput, ConfirmOnboardingPhoneBindingInput, OnboardingPhoneBound, OnboardingPhoneBindingStarted, } from '../../onboarding.js';
export const onboardingRoutes = {
    flow: {
        method: 'GET',
        path: '/onboarding/flow',
        query: OnboardingFlowQuery,
        response: OnboardingFlowRevision,
    },
    options: {
        method: 'GET',
        path: '/onboarding/options',
        query: OnboardingFlowQuery,
        response: OnboardingOptionCatalogue,
    },
    me: {
        method: 'GET',
        path: '/me/onboarding',
        response: OnboardingStatusView,
    },
    saveStep: {
        method: 'PATCH',
        path: '/me/onboarding/steps/:stepId',
        body: SaveOnboardingStepInput,
        response: OnboardingStatusView,
    },
    complete: {
        method: 'POST',
        path: '/me/onboarding/complete',
        body: CompleteOnboardingInput,
        response: OnboardingStatusView,
    },
    startPhoneBinding: {
        method: 'POST',
        path: '/me/phone-verification/start',
        body: StartOnboardingPhoneBindingInput,
        response: OnboardingPhoneBindingStarted,
    },
    confirmPhoneBinding: {
        method: 'POST',
        path: '/me/phone-verification/confirm',
        body: ConfirmOnboardingPhoneBindingInput,
        response: OnboardingPhoneBound,
    },
};
//# sourceMappingURL=routes.js.map